<!-- 数字运维 -->
<template>
  <div class="dtwin-container">
    <VerticalBanner
      :lists="bannersList"
      :indicatorPosition="'none'"
      :height="'640px'"
      :isShowMore="true"
      @click="openUrl"
    />
    <Solution />

    <TwinHighwayIntro />

    <TwinWaterwayIntro />

    <TwinCityIntro />

    <!-- 获取产品 -->
    <ProductGet
      title="基础设施运维数字孪生解决方案"
      subTitle="为道路、航道、城市基础设施运维管理带来全新模式！"
      :bgImage="require('@/assets/images/dtwin/getNow_bg.png')"
      :contactBtn="null"
      :downLoadBtn="{
        label: '下载产品手册',
        fileUrl: '/download?anchor=manual',
        show: true,
      }"
    />
  </div>
</template>

<script>
import VerticalBanner from "@/components/VerticalBanner.vue";
import ProductGet from "@/components/ProductGet.vue";
import Solution from "./Solution.vue";
import TwinCityIntro from "./TwinCityIntro.vue";
import TwinHighwayIntro from "./TwinHighwayIntro.vue";
import TwinWaterwayIntro from "./TwinWaterwayIntro.vue";

import { clientBannerListApi } from "@/api/api";
export default {
  name: "Dtwin",
  components: {
    VerticalBanner,
    Solution,
    TwinCityIntro,
    ProductGet,
    TwinHighwayIntro,
    TwinWaterwayIntro,
  },
  data() {
    return {
      bannersList: [
        {
          id: "1",
          title: "数字孪生公路基础平台",
          subTitle:
            "大数据分析与智能传感技术和公路运维管理的深度融合\n 实现公路全生命周期的高效管控与精准养护",
          picUrl: require("@/assets/images/dtwin/banner1.png"),
          bannerLink: "",
        },
        {
          id: "2",
          title: "数字孪生航道基础平台",
          subTitle:
            "多源数据融合技术与航道全流程管理的深度融合\n 实现航道管理的精准化与智能化。 ",
          picUrl: require("@/assets/images/dtwin/banner2.png"),
          bannerLink: "",
        },
        {
          id: "3",
          title: "数字孪生城市基础平台",
          subTitle: "AIoT 融合技术与城市生活场景的深度融合\n 重塑城市管理体验",
          picUrl: require("@/assets/images/dtwin/banner3.png"),
          bannerLink: "",
        },
      ],
    };
  },
  created() {
    // this.getBanner();
  },
  methods: {
    openUrl() {
      // TODO
    },
    async getBanner() {
      // let data = await this.bannerApi();
      // this.banners = data
    },

    bannerApi() {
      return new Promise((resolve, reject) => {
        clientBannerListApi().then((res) => {
          if (res.code === 200) {
            resolve(res.rows);
          }
        });
      });
    },
  },
};
</script>

<style lang="scss">
.dtwin-container {
  width: 100%;
  height: 100%;
  .dtwin-get-wrapper {
    width: 990px;
    margin: 0 auto;
    padding: 52px 0;
    text-align: center;
  }
  .dtwin-get {
    width: 100%;
    height: 240px;
    background: url("~@/assets/images/dtwin/getNow_bg.png") no-repeat center;
    background-size: cover;
    color: #fff;
  }
  .dtwin-get-header {
    margin-bottom: 24px;
    font-weight: 600;
    font-size: 24px;
    color: #fff;
    line-height: 24px;
    text-align: left;
    font-style: normal;
  }
  .dtwin-get-subTitle {
    margin-bottom: 40px;
    font-weight: 400;
    font-size: 18px;
    color: #fff;
    line-height: 27px;
    text-align: justify;
    font-style: normal;
  }
  .dtwin-get-footer {
    text-align: left;
    .dtwin-get-btn {
      padding: 8px 12px;
      font-size: 14px;
      color: #000;
      text-align: center;
      background: #fff;
      border-radius: 2px;
      &:first-child {
        margin-right: 20px;
        cursor: pointer;
        &:hover {
          opacity: 0.8;
        }
      }
    }
  }
}
</style>
